<template>
    <header id="header">
        <!-- <video autoplay muted loop id="myVideo">
            <source src="../../public/videos/maralto.mp4" type="video/mp4">
        </video> -->
        <img src="../../public/images/marca/Marca.png" alt="">
        <a href="#description">
            <arrowdown/>
        </a>
    </header>
</template>    
<script>
import arrowdown from './icones/arrowdown'
export default { 
    components: {arrowdown}
}
</script>
<style scoped lang="scss">
    header{
        width:100%;
        height: 100vh;
        background-attachment: fixed;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-image:url('../../public/images/background/header.png');
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        // z-index: -1;
        #myVideo {
            position: absolute;
            z-index: 1;
            right: 0;
            bottom: 0;
            min-width: 100%;
            min-height: 100%;
            }
        img{
            max-width: 90%;
            margin-bottom:250px;
            position: relative;
            z-index:2;
        }
        a{
            position: absolute;
            bottom: 70px;
            z-index: 2;
        }
    }
    @media(max-width:900px){
        header{
            img{
                margin-bottom:150px;
            }
        }
    }
    
</style>